(function () {
  var instances = new WeakMap();

  function initCursor() {
    if (document.body.classList.contains('rdv7-privacy-body')) return;

    var cursor = document.querySelector('[data-rdv7-custom-cursor]');
    var cursorMq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 901px)');
    if (!cursor || !cursorMq.matches || cursor.dataset.rdv7CursorReady === 'true') return;

    cursor.dataset.rdv7CursorReady = 'true';
    var mouseX = window.innerWidth / 2;
    var mouseY = window.innerHeight / 2;
    var cursorX = mouseX;
    var cursorY = mouseY;
    var frame;
    var hoverSelector = 'a,button,.btn,.prev-cta,.sc-btn,input,textarea,label';
    var heroTextSelector = 'h1,h2,h3,h4,h5,h6,p,.rdv7-ghost,.rdv7-line,.rdv7-hostedby,.rdv7-x,.confirmed-ghost,.confirmed-line';
    var preservedColorSelector = '.hbh-title strong,.spk-heading strong,.spk-num,.brandname,.more-title,.more-plus svg,.ae-time,.cap-time,.prev-label,.foot-sponsors-title,.foot-sponsor-group-title,.tag';
    var preservedColorTarget = null;
    var preservedColorClone = null;

    var removePreservedColorClone = function () {
      if (preservedColorClone) preservedColorClone.remove();
      preservedColorClone = null;
      preservedColorTarget = null;
    };

    var createPreservedColorClone = function (target) {
      if (preservedColorTarget === target) return;
      removePreservedColorClone();
      if (!target) return;

      var computed = window.getComputedStyle(target);
      var clone = target.cloneNode(true);
      clone.className = 'rdv7-cursor-color-clone';
      clone.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(computed, function (property) {
        clone.style.setProperty(property, computed.getPropertyValue(property));
      });
      clone.style.setProperty('position', 'fixed', 'important');
      clone.style.setProperty('z-index', '10001', 'important');
      clone.style.setProperty('margin', '0', 'important');
      clone.style.setProperty('pointer-events', 'none', 'important');
      clone.style.setProperty('transform', 'none', 'important');
      clone.style.setProperty('filter', 'none', 'important');
      clone.style.setProperty('color', '#fff', 'important');
      clone.style.setProperty('stroke', '#fff', 'important');
      clone.style.setProperty('-webkit-text-fill-color', '#fff', 'important');
      clone.style.setProperty('background', 'none', 'important');
      if (target.matches('.tag')) clone.style.setProperty('border-color', '#fff', 'important');
      document.body.appendChild(clone);
      preservedColorTarget = target;
      preservedColorClone = clone;
    };

    var syncPreservedColorClone = function () {
      if (!preservedColorTarget || !preservedColorClone) return;
      if (!preservedColorTarget.isConnected) {
        removePreservedColorClone();
        return;
      }

      var rect = preservedColorTarget.getBoundingClientRect();
      preservedColorClone.style.left = rect.left + 'px';
      preservedColorClone.style.top = rect.top + 'px';
      preservedColorClone.style.width = rect.width + 'px';
      preservedColorClone.style.height = rect.height + 'px';
      var clip = 'circle(13px at ' + (cursorX - rect.left) + 'px ' + (cursorY - rect.top) + 'px)';
      preservedColorClone.style.clipPath = clip;
      preservedColorClone.style.webkitClipPath = clip;
    };

    var updateMediaCursor = function (target) {
      var overHero = target.closest('.rdv7-hero,.rdv7-confirmed-hero');
      var overHeroText = target.closest(heroTextSelector);
      var overMedia = target.closest('.photo,.evp-collage-item,video');
      var overInteractive = target.closest(hoverSelector);
      var preservedColor = target.closest(preservedColorSelector);

      if (!preservedColor || !preservedColor.closest('.rdv7-fall-content') || overMedia || overInteractive) {
        preservedColor = null;
      }
      createPreservedColorClone(preservedColor);
      cursor.classList.toggle('is-over-media', Boolean(overMedia || (overHero && !overHeroText)));
    };
    var moveCursor = function (event) {
      mouseX = event.clientX;
      mouseY = event.clientY;
      updateMediaCursor(event.target);
    };
    var renderCursor = function () {
      cursorX += (mouseX - cursorX) * 0.35;
      cursorY += (mouseY - cursorY) * 0.35;
      cursor.style.transform = 'translate(' + cursorX + 'px,' + cursorY + 'px)';
      syncPreservedColorClone();
      frame = window.requestAnimationFrame(renderCursor);
    };
    var showHoverCursor = function (event) {
      updateMediaCursor(event.target);
      if (event.target.closest(hoverSelector)) cursor.classList.add('is-hover');
    };
    var hideHoverCursor = function (event) {
      if (event.target.closest(hoverSelector)) cursor.classList.remove('is-hover');
    };

    document.addEventListener('mousemove', moveCursor);
    document.addEventListener('mouseover', showHoverCursor);
    document.addEventListener('mouseout', hideHoverCursor);
    frame = window.requestAnimationFrame(renderCursor);
  }

  function init(root) {
    if (!root || instances.has(root)) return;

    var cleanups = [];
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    var speakers = root.querySelector('[data-rdv7-speakers]');
    if (speakers) {
      var speakerTextureUrl = speakers.getAttribute('data-rdv7-speaker-texture');
      if (speakerTextureUrl) {
        var loadSpeakerTexture = function () {
          speakers.style.setProperty('--rdv7-speaker-texture', 'url("' + speakerTextureUrl + '")');
        };

        if (typeof IntersectionObserver === 'undefined') {
          loadSpeakerTexture();
        } else {
          var speakerTextureObserver = new IntersectionObserver(function (entries) {
            if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
            loadSpeakerTexture();
            speakerTextureObserver.disconnect();
          }, { rootMargin: '600px 0px' });
          speakerTextureObserver.observe(speakers);
          cleanups.push(function () { speakerTextureObserver.disconnect(); });
        }
      }
    }

    var speakersCarousel = root.querySelector('[data-rdv7-speakers-carousel]');
    if (speakersCarousel) {
      var speakersTrack = speakersCarousel.querySelector('[data-rdv7-speakers-track]');
      var speakersViewport = speakersCarousel.querySelector('[data-rdv7-speakers-viewport]');
      var speakersPrev = speakersCarousel.querySelector('[data-rdv7-speakers-prev]');
      var speakersNext = speakersCarousel.querySelector('[data-rdv7-speakers-next]');
      var speakersToggle = speakersCarousel.querySelector('[data-rdv7-speakers-toggle]');

      if (speakersTrack && speakersViewport && speakersPrev && speakersNext) {
        var speakerCards = Array.prototype.slice.call(speakersTrack.children);
        var speakerStep = function () {
          if (!speakerCards.length) return 0;
          var styles = window.getComputedStyle(speakersTrack);
          var gap = parseFloat(styles.columnGap || styles.gap || '24') || 24;
          return speakerCards[0].getBoundingClientRect().width + gap;
        };
        var renderSpeakers = function () {
          if (speakersCarousel.classList.contains('is-expanded')) return;
          var maxScroll = Math.max(0, speakersViewport.scrollWidth - speakersViewport.clientWidth);
          speakersPrev.disabled = speakersViewport.scrollLeft <= 1;
          speakersNext.disabled = speakersViewport.scrollLeft >= maxScroll - 1;
        };
        var showPreviousSpeaker = function () {
          speakersViewport.scrollBy({ left: -speakerStep(), behavior: reducedMotion ? 'auto' : 'smooth' });
        };
        var showNextSpeaker = function () {
          speakersViewport.scrollBy({ left: speakerStep(), behavior: reducedMotion ? 'auto' : 'smooth' });
        };

        speakersPrev.addEventListener('click', showPreviousSpeaker);
        speakersNext.addEventListener('click', showNextSpeaker);
        speakersViewport.addEventListener('scroll', renderSpeakers, { passive: true });
        window.addEventListener('resize', renderSpeakers);
        window.requestAnimationFrame(renderSpeakers);
        cleanups.push(function () {
          speakersPrev.removeEventListener('click', showPreviousSpeaker);
          speakersNext.removeEventListener('click', showNextSpeaker);
          speakersViewport.removeEventListener('scroll', renderSpeakers);
          window.removeEventListener('resize', renderSpeakers);
        });

        if (speakersToggle) {
          var toggleSpeakers = function () {
            var expanded = speakersCarousel.classList.toggle('is-expanded');
            if (expanded) speakersViewport.scrollLeft = 0;
            speakersToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            speakersToggle.textContent = speakersToggle.getAttribute(expanded ? 'data-collapse-label' : 'data-expand-label');
            if (!expanded) renderSpeakers();
          };
          speakersToggle.addEventListener('click', toggleSpeakers);
          cleanups.push(function () { speakersToggle.removeEventListener('click', toggleSpeakers); });
        }
      }
    }

    var revealElements = Array.prototype.slice.call(root.querySelectorAll('.resolve'));
    if (reducedMotion || typeof IntersectionObserver === 'undefined') {
      revealElements.forEach(function (element) { element.classList.add('in'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.15 });
      revealElements.forEach(function (element) { revealObserver.observe(element); });
      cleanups.push(function () { revealObserver.disconnect(); });
    }

    var eveningCollage = root.querySelector('[data-rdv7-evening-collage]');
    if (eveningCollage) {
      var collageFraming = {
        'evp-collage-image--1': { x: 0, y: 0 },
        'evp-collage-image--1b': { x: 20.79, y: 0 },
        'evp-collage-image--2': { x: 0, y: 0 },
        'evp-collage-image--2b': { x: 0, y: 24.38 },
        'evp-collage-image--3': { x: 4.46, y: 0 },
        'evp-collage-image--3b': { x: 0, y: 0 },
        'evp-collage-image--4': { x: 0, y: 0 },
        'evp-collage-image--4b': { x: 0, y: -37.76 },
      };
      var framedImages = Array.prototype.slice.call(eveningCollage.querySelectorAll('.evp-collage-image'));
      var getCollageFraming = function (image) {
        var className = Object.keys(collageFraming).find(function (name) { return image.classList.contains(name); });
        return className ? collageFraming[className] : { x: 0, y: 0 };
      };
      var frameCollageImage = function (image) {
        var frame = image.parentElement;
        if (!frame || !image.naturalWidth || !image.naturalHeight || !frame.clientWidth || !frame.clientHeight) return;

        var baseScale = Math.max(frame.clientWidth / image.naturalWidth, frame.clientHeight / image.naturalHeight);
        var renderedWidth = image.naturalWidth * baseScale;
        var renderedHeight = image.naturalHeight * baseScale;
        var framing = getCollageFraming(image);
        var maxX = Math.max(0, (renderedWidth / frame.clientWidth - 1) * 50);
        var maxY = Math.max(0, (renderedHeight / frame.clientHeight - 1) * 50);
        var x = Math.max(-maxX, Math.min(maxX, framing.x));
        var y = Math.max(-maxY, Math.min(maxY, framing.y));

        image.style.inset = 'auto';
        image.style.width = renderedWidth + 'px';
        image.style.height = renderedHeight + 'px';
        image.style.left = (50 + x) + '%';
        image.style.top = (50 + y) + '%';
        image.style.transform = 'translate(-50%, -50%)';
      };
      var frameCollageImages = function () {
        framedImages.forEach(frameCollageImage);
      };
      var onCollageImageLoad = function (event) { frameCollageImage(event.currentTarget); };
      framedImages.forEach(function (image) {
        image.addEventListener('load', onCollageImageLoad);
        if (image.complete) frameCollageImage(image);
      });

      var collageResizeObserver;
      if (typeof ResizeObserver !== 'undefined') {
        collageResizeObserver = new ResizeObserver(frameCollageImages);
        collageResizeObserver.observe(eveningCollage);
      } else {
        window.addEventListener('resize', frameCollageImages);
      }
      cleanups.push(function () {
        framedImages.forEach(function (image) { image.removeEventListener('load', onCollageImageLoad); });
        if (collageResizeObserver) collageResizeObserver.disconnect();
        else window.removeEventListener('resize', frameCollageImages);
      });
    }
    if (eveningCollage && !reducedMotion) {
      var collageInView = typeof IntersectionObserver === 'undefined';
      var collageRotators = Array.prototype.slice.call(eveningCollage.querySelectorAll('[data-rdv7-evening-rotator]')).map(function (rotator) {
        return {
          element: rotator,
          images: Array.prototype.slice.call(rotator.querySelectorAll('.evp-collage-image')),
          current: 0,
          delay: parseInt(rotator.getAttribute('data-rotation-delay'), 10) || 4200,
          timer: null,
        };
      }).filter(function (rotator) { return rotator.images.length > 1; });

      var stopCollage = function () {
        collageRotators.forEach(function (rotator) {
          if (rotator.timer) window.clearInterval(rotator.timer);
          rotator.timer = null;
        });
      };
      var startCollage = function () {
        if (!collageInView || document.hidden) return;
        collageRotators.forEach(function (rotator) {
          if (rotator.timer) return;
          rotator.timer = window.setInterval(function () {
            rotator.images[rotator.current].classList.remove('is-active');
            rotator.current = (rotator.current + 1) % rotator.images.length;
            rotator.images[rotator.current].classList.add('is-active');
          }, rotator.delay);
        });
      };
      var onCollageVisibility = function () {
        if (document.hidden) stopCollage();
        else startCollage();
      };
      var collageObserver;
      if (typeof IntersectionObserver === 'undefined') {
        startCollage();
      } else {
        collageObserver = new IntersectionObserver(function (entries) {
          collageInView = entries.some(function (entry) { return entry.isIntersecting; });
          if (collageInView) startCollage();
          else stopCollage();
        }, { rootMargin: '120px 0px' });
        collageObserver.observe(eveningCollage);
      }
      document.addEventListener('visibilitychange', onCollageVisibility);
      cleanups.push(function () {
        stopCollage();
        if (collageObserver) collageObserver.disconnect();
        document.removeEventListener('visibilitychange', onCollageVisibility);
      });
    }

    var room = root.querySelector('[data-rdv7-room-marquee]');
    var roomToggle = root.querySelector('[data-rdv7-room-toggle]');
    if (room && roomToggle) {
      var pauseLabel = roomToggle.getAttribute('aria-label') || 'Pause company marquee';
      var playLabel = pauseLabel.replace(/^Pause/i, 'Play');
      var toggleRoom = function () {
        var paused = room.classList.toggle('paused');
        roomToggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        roomToggle.setAttribute('aria-label', paused ? playLabel : pauseLabel);
      };
      roomToggle.setAttribute('aria-pressed', 'false');
      roomToggle.addEventListener('click', toggleRoom);
      cleanups.push(function () { roomToggle.removeEventListener('click', toggleRoom); });

      Array.prototype.slice.call(room.querySelectorAll('.room-row')).forEach(function (row) {
        var track = row.querySelector('.room-track');
        if (!track) return;
        var pauseRow = function () { track.style.animationPlayState = 'paused'; };
        var resumeRow = function () { track.style.animationPlayState = ''; };
        row.addEventListener('mouseenter', pauseRow);
        row.addEventListener('mouseleave', resumeRow);
        cleanups.push(function () {
          row.removeEventListener('mouseenter', pauseRow);
          row.removeEventListener('mouseleave', resumeRow);
        });
      });
    }

    var scheduleList = root.querySelector('[data-rdv7-schedule-list]');
    var schedulePreview = root.querySelector('[data-rdv7-schedule-preview]');
    if (canHover && scheduleList && schedulePreview) {
      var rows = Array.prototype.slice.call(scheduleList.querySelectorAll('[data-schedule-index]'));
      var previews = Array.prototype.slice.call(schedulePreview.querySelectorAll('[data-schedule-index]'));
      var showPreview = function (index) {
        schedulePreview.classList.add('is-active');
        previews.forEach(function (preview) {
          preview.classList.toggle('is-current', preview.getAttribute('data-schedule-index') === index);
        });
      };
      var hidePreview = function () { schedulePreview.classList.remove('is-active'); };
      var movePreview = function (event) {
        schedulePreview.style.left = event.clientX + 'px';
        schedulePreview.style.top = event.clientY + 'px';
      };

      rows.forEach(function (row) {
        var index = row.getAttribute('data-schedule-index');
        var enter = function (event) {
          movePreview(event);
          showPreview(index);
        };
        var focus = function () {
          var rect = row.getBoundingClientRect();
          movePreview({
            clientX: rect.left + rect.width / 2,
            clientY: rect.top + rect.height / 2,
          });
          showPreview(index);
        };
        row.addEventListener('mouseenter', enter);
        row.addEventListener('focus', focus);
        row.addEventListener('blur', hidePreview);
        cleanups.push(function () {
          row.removeEventListener('mouseenter', enter);
          row.removeEventListener('focus', focus);
          row.removeEventListener('blur', hidePreview);
        });
      });
      scheduleList.addEventListener('mousemove', movePreview);
      scheduleList.addEventListener('mouseleave', hidePreview);
      cleanups.push(function () {
        scheduleList.removeEventListener('mousemove', movePreview);
        scheduleList.removeEventListener('mouseleave', hidePreview);
      });
    }

    Array.prototype.slice.call(root.querySelectorAll('.cards')).forEach(function (track) {
      var mobileCardsMq = window.matchMedia('(max-width: 880px)');
      var currentCard = 0;
      var cardUserActive = false;
      var cardResumeTimer;
      var cardAutoTimer;
      var scrollFrame;

      var cardItems = function () {
        return Array.prototype.slice.call(track.querySelectorAll('.card'));
      };
      var updateCardActive = function () {
        var items = cardItems();
        if (!items.length) return;
        var closest = 0;
        var closestDistance = Infinity;
        items.forEach(function (item, index) {
          var distance = Math.abs(item.offsetLeft - track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = index;
          }
        });
        currentCard = closest;
      };
      var goToCard = function (index) {
        var items = cardItems();
        if (!items.length) return;
        currentCard = ((index % items.length) + items.length) % items.length;
        track.scrollTo({ left: items[currentCard].offsetLeft, behavior: 'smooth' });
      };
      var stopCardAuto = function () {
        if (cardAutoTimer) window.clearInterval(cardAutoTimer);
        cardAutoTimer = null;
      };
      var startCardAuto = function () {
        stopCardAuto();
        if (reducedMotion || !mobileCardsMq.matches) return;
        cardAutoTimer = window.setInterval(function () {
          if (!cardUserActive && mobileCardsMq.matches) goToCard(currentCard + 1);
        }, 3800);
      };
      var pauseCardAuto = function () {
        cardUserActive = true;
        if (cardResumeTimer) window.clearTimeout(cardResumeTimer);
      };
      var scheduleCardResume = function () {
        if (cardResumeTimer) window.clearTimeout(cardResumeTimer);
        cardResumeTimer = window.setTimeout(function () { cardUserActive = false; }, 2500);
      };
      var onCardScroll = function () {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateCardActive);
        scheduleCardResume();
      };
      var onCardMediaChange = function () {
        if (mobileCardsMq.matches) startCardAuto();
        else stopCardAuto();
      };

      track.addEventListener('scroll', onCardScroll, { passive: true });
      track.addEventListener('pointerdown', pauseCardAuto);
      track.addEventListener('touchstart', pauseCardAuto, { passive: true });
      track.addEventListener('pointerup', scheduleCardResume);
      track.addEventListener('touchend', scheduleCardResume);
      track.addEventListener('pointercancel', scheduleCardResume);
      mobileCardsMq.addEventListener('change', onCardMediaChange);
      startCardAuto();

      cleanups.push(function () {
        stopCardAuto();
        if (cardResumeTimer) window.clearTimeout(cardResumeTimer);
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        track.removeEventListener('scroll', onCardScroll);
        track.removeEventListener('pointerdown', pauseCardAuto);
        track.removeEventListener('touchstart', pauseCardAuto);
        track.removeEventListener('pointerup', scheduleCardResume);
        track.removeEventListener('touchend', scheduleCardResume);
        track.removeEventListener('pointercancel', scheduleCardResume);
        mobileCardsMq.removeEventListener('change', onCardMediaChange);
      });
    });

    instances.set(root, function () {
      cleanups.forEach(function (cleanup) { cleanup(); });
      instances.delete(root);
    });
  }

  function initAll(scope) {
    initCursor();
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-rdv7-fall-content]')).forEach(init);
  }

  function destroyWithin(scope) {
    Array.prototype.slice.call(scope.querySelectorAll('[data-rdv7-fall-content]')).forEach(function (root) {
      var destroy = instances.get(root);
      if (destroy) destroy();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroyWithin(event.target); });
})();
